import { useState } from "react";
import { X, HelpCircle, Calendar, UserSquare2, Inbox, Mail, Users, ChevronRight } from "lucide-react";

const SECTIONS = [
  {
    id: "login",
    title: "1. Вход в админку",
    body: [
      "Откройте страницу teamastana.com/login",
      "Введите email и пароль → нажмите «Войти»",
      "Откроется панель управления /admin",
      "",
      "🔑 Super Admin: superadmin@teamastana.com / AstanaSuper2026!",
      "👤 Обычный админ — регистрируется на /register и ждёт одобрения от Super Admin",
    ],
  },
  {
    id: "shows",
    icon: Calendar,
    title: "2. Концерты — добавить, изменить, отправить в архив",
    body: [
      "➕ ДОБАВИТЬ КОНЦЕРТ:",
      "1) «Концерты» → «+ Добавить»",
      "2) Заполнить: дата+время (YYYY-MM-DD HH:MM), город, страна, country code (US/CA/KZ/DE/RU/AZ/UZ/KG), площадка, адрес, ссылка на билеты",
      "3) Выбрать статус:",
      "   🟡 on_sale — билеты в продаже (жёлтая кнопка)",
      "   ⚠️ low_tickets — «Осталось мало»",
      "   🔴 sold_out — распродано",
      "4) Сохранить",
      "",
      "✏️ ИЗМЕНИТЬ (поменять ссылку на кассу, дату, площадку):",
      "Найти строку → карандаш 🖉 → изменить → Save ✓",
      "",
      "🗄 АРХИВ — работает АВТОМАТИЧЕСКИ:",
      "Концерт сам уходит в раздел «Архив» через 6 часов после даты события. Вручную ничего двигать не надо.",
      "",
      "🗑 УДАЛИТЬ → корзина (необратимо)",
    ],
  },
  {
    id: "team",
    icon: UserSquare2,
    title: "3. Команда — фото, роли, био, Instagram",
    body: [
      "✏️ ИЗМЕНИТЬ УЧАСТНИКА:",
      "«Команда» → карандаш 🖉",
      "Можно менять: Имя (RU+EN), Роль (RU+EN), Био (RU+EN), Фото, Instagram, Order (порядок)",
      "Сохранить ✓",
      "",
      "📷 КАК ПОМЕНЯТЬ ФОТО:",
      "• Быстрый: вставить прямой URL картинки (.jpg/.png/.webp)",
      "• Постоянный: прислать фото разработчику в чат → он загрузит в /backend/static/team/ → в поле image прописать /api/static/team/имя.jpg",
      "",
      "➕ Добавить нового → «+ Добавить»",
      "🗑 Удалить → корзина",
    ],
  },
  {
    id: "bookings",
    icon: Inbox,
    title: "4. Заявки — букинг и пресса",
    body: [
      "Все запросы с формы «Букинг и пресса» приходят сюда",
      "Видно: имя, email, организация, город, тип запроса, сообщение, дата",
      "Клик по email → откроется почта для ответа",
      "После ответа можно удалить запись 🗑",
    ],
  },
  {
    id: "newsletter",
    icon: Mail,
    title: "5. Подписчики Newsletter",
    body: [
      "Email тех, кто подписался на анонсы тура из футера сайта",
      "Можно экспортнуть для рассылки (через Mailchimp / SendGrid — попросите разработчика подключить)",
    ],
  },
  {
    id: "users",
    icon: Users,
    title: "6. Пользователи (только Super Admin)",
    body: [
      "✅ ОДОБРИТЬ НОВОГО АДМИНА:",
      "1) Кто-то регистрируется на /register → статус PENDING",
      "2) Вы видите его в «Пользователи»",
      "3) Approve ✓ — он может работать  /  Reject ✗ — отклонить",
      "",
      "🗑 Удалить админа → корзина (нельзя удалить самого себя)",
      "",
      "⚠ БЕЗОПАСНОСТЬ:",
      "• Никогда не делитесь паролем Super Admin",
      "• Каждому человеку — отдельный обычный аккаунт",
      "• Уволился — сразу удалить",
    ],
  },
  {
    id: "limits",
    title: "❌ Что НЕЛЬЗЯ менять самостоятельно (только через разработчика)",
    body: [
      "Эти разделы редактируются только из кода — напишите в чат разработчику:",
      "",
      "• Главный постер Hero (USA & Canada)",
      "• Тексты блока «О команде» (3 абзаца)",
      "• Достижения (список со звёздочками)",
      "• YouTube-видео в галерее видео",
      "• Фото в галерее «Со сцены»",
      "• Статьи прессы «О нас говорят»",
      "• Партнёры в карусели внизу",
      "• Контакты в футере (Instagram / YouTube / Telegram)",
      "",
      "Чтобы поменять — просто напишите: «замените X на Y» — разработчик внесёт.",
    ],
  },
  {
    id: "shortcuts",
    title: "💡 Быстрая шпаргалка",
    body: [
      "• Поменять ссылку на кассу → Концерты → 🖉 → ticket_url → Save",
      "• Билеты распроданы → Концерты → 🖉 → status: sold_out → Save",
      "• Концерт прошёл → уходит в архив АВТОМАТИЧЕСКИ",
      "• Добавить город → Концерты → + → заполнить → Save",
      "• Заменить фото человека → Команда → 🖉 → image → Save",
      "• Сменить Instagram → Команда → 🖉 → instagram → Save",
      "• Одобрить нового админа → Пользователи → ✓ (только Super Admin)",
      "",
      "🚪 Выход → кнопка «Выйти» сверху справа",
    ],
  },
];

export const HelpButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 text-xs tracking-widest uppercase text-white/70 hover:text-[#FFDE00] border border-white/15 hover:border-[#FFDE00]/70 px-3 py-1.5 transition-colors"
        data-testid="admin-help-btn"
        title="Руководство админа"
      >
        <HelpCircle size={14} /> <span className="hidden md:inline">Помощь</span>
      </button>

      {open && <HelpModal onClose={() => setOpen(false)} />}
    </>
  );
};

const HelpModal = ({ onClose }) => {
  const [activeId, setActiveId] = useState(SECTIONS[0].id);
  const active = SECTIONS.find((s) => s.id === activeId);

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-stretch md:items-center justify-center md:p-6"
      onClick={onClose}
      data-testid="admin-help-modal"
    >
      <div
        className="relative w-full md:max-w-5xl bg-[#0a0a0a] border border-white/15 flex flex-col md:flex-row max-h-screen md:max-h-[90vh] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="md:hidden flex items-center justify-between p-5 border-b border-white/10">
          <div className="flex items-center gap-2">
            <HelpCircle size={18} className="text-[#FFDE00]" />
            <span className="font-display text-xl tracking-tight">Помощь</span>
          </div>
          <button
            onClick={onClose}
            className="text-white/60 hover:text-white"
            data-testid="admin-help-close-m"
          >
            <X size={20} />
          </button>
        </div>

        {/* Sidebar */}
        <aside className="md:w-64 md:shrink-0 md:border-r border-white/10 md:bg-black/40 overflow-y-auto">
          <div className="hidden md:flex items-center gap-2 px-5 pt-6 pb-4">
            <HelpCircle size={18} className="text-[#FFDE00]" />
            <span className="font-display text-xl tracking-tight">
              Руководство админа
            </span>
          </div>
          <nav className="flex md:flex-col gap-px overflow-x-auto md:overflow-x-visible bg-white/10">
            {SECTIONS.map((s) => {
              const Icon = s.icon;
              const isActive = s.id === activeId;
              return (
                <button
                  key={s.id}
                  onClick={() => setActiveId(s.id)}
                  className={`text-left flex items-center gap-2 px-4 md:px-5 py-3 text-[11px] md:text-xs tracking-widest uppercase font-semibold transition-colors whitespace-nowrap md:whitespace-normal ${
                    isActive
                      ? "bg-[#FFDE00] text-black"
                      : "bg-[#0a0a0a] text-white/65 hover:bg-[#150003] hover:text-white"
                  }`}
                  data-testid={`admin-help-nav-${s.id}`}
                >
                  {Icon && <Icon size={13} />}
                  <span className="md:flex-1 leading-tight">{s.title}</span>
                  {isActive && (
                    <ChevronRight size={13} className="hidden md:inline" />
                  )}
                </button>
              );
            })}
          </nav>
        </aside>

        {/* Content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="hidden md:flex items-center justify-between p-5 border-b border-white/10">
            <div className="text-xs tracking-widest uppercase text-white/45">
              {active?.title}
            </div>
            <button
              onClick={onClose}
              className="text-white/60 hover:text-white inline-flex items-center gap-1.5 text-xs tracking-widest uppercase"
              data-testid="admin-help-close"
            >
              <X size={16} /> Закрыть
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-5 md:p-8">
            <h2 className="font-display text-2xl md:text-3xl tracking-tighter mb-5 text-[#FFDE00]">
              {active?.title}
            </h2>
            <div className="space-y-2.5 font-light leading-relaxed text-white/85">
              {active?.body.map((line, i) =>
                line === "" ? (
                  <div key={i} className="h-2" />
                ) : (
                  <div
                    key={i}
                    className={`text-sm md:text-[15px] ${
                      line.startsWith("•") || /^\d\)/.test(line)
                        ? "pl-2"
                        : line.endsWith(":") ||
                          line.startsWith("➕") ||
                          line.startsWith("✏️") ||
                          line.startsWith("🗄") ||
                          line.startsWith("🗑") ||
                          line.startsWith("📷") ||
                          line.startsWith("✅") ||
                          line.startsWith("⚠")
                        ? "text-[#FFDE00] font-semibold tracking-wide pt-2"
                        : ""
                    }`}
                  >
                    {line}
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpButton;
